<div class="card border-primary ui-g" style="display: block; padding: .5em;">
    <div class="ui-g ui-fluid">
        <p-panel header="Datos del usuario">
            <div class="ui-g ui-fluid">
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Apellidos: </label>
                    <label> {{datosUsuario.apellidos}}</label>
                </div>
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Nombres: </label>
                    <label> {{datosUsuario.nombres}}</label>
                </div>

                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Usuario: </label>
                    <label> {{datosUsuario.usuario}}</label>
                </div>
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Dni: </label>
                    <label> {{datosUsuario.nroDocumento}}</label>
                </div>
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Correo Electrónico: </label>

                    <label> {{datosUsuario.email}}</label>

                </div>
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Empresa: </label>
                    <label> {{datosUsuario.empresa}}</label>
                </div>
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Rol: </label>
                    <label> {{datosUsuario.rol}}</label>
                </div>
                <div class="ui-g-12 ui-md-12">
                    <label [style]="{'width':'40%'}">Cargo: </label>
                    <label> {{datosUsuario.cargo}}</label>
                </div>



            </div>
        </p-panel>
    </div>
</div>